import { useMemo, useState } from 'react'
import type { Location } from '../../../types/location'

function filterLocationsByQuery(locations: Location[], searchQuery: string): Location[] {
  const q = searchQuery.trim().toLowerCase()
  if (!q) return locations
  return locations.filter(
    (loc) => loc.name.toLowerCase().includes(q) || (loc.suburb?.toLowerCase().includes(q) ?? false)
  )
}

export function useLocationSearch(locations: Location[]) {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredLocations = useMemo(
    () => filterLocationsByQuery(locations, searchQuery),
    [locations, searchQuery]
  )

  return { searchQuery, setSearchQuery, filteredLocations }
}
